exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DateInput_input {\n    box-sizing: border-box;\n}\n\n.DayPickerNavigation__verticalDefault {\n    text-align: center;\n    height: initial;\n    padding: 10px 0px;\n}\n\n.DayPickerNavigation_svg__vertical {\n    height: 20px;\n}\n", ""]);

// exports
